/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/JiraBusinessShortcutsAppMemoQuery$parameters.ts';
import type { JiraBusinessShortcutsAppMemoQuery } from './__generated__/JiraBusinessShortcutsAppMemoQuery.graphql.ts';

type ShortcutsEntrypointComponent = EntryPointComponent<
	{
		shortcutsQuery: JiraBusinessShortcutsAppMemoQuery;
	},
	{},
	{},
	{}
>;

export const shortcutsEntrypoint: EntryPoint<ShortcutsEntrypointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForUserVisible<ShortcutsEntrypointComponent>(
			/* webpackChunkName: "async-business-shortcuts-entrypoint" */ './JiraBusinessShortcutsAppMemo.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
			const projectKey = context.match.params.projectKey;

			if (projectKey == null) {
				throw new Error('Project key missing');
			}

			return {
				queries: {
					shortcutsQuery: {
						options: {
							fetchPolicy: 'store-and-network' as const,
						},
						parameters,
						variables: {
							cloudId,
							projectKey,
						},
					},
				},
			};
		},
	});
